import { Reveal, Lines, SectionTag } from "../site/Motion";

const PANELS = [
  { src: "/assets/interior-display.webp", tag: "Display 12.3\"", title: "Il cockpit digitale", text: "Un'interfaccia touch da 12.3 pollici porta navigazione, media, stato di carica e veicolo sotto gli occhi del guidatore.", cls: "lg:mt-0" },
  { src: "/assets/interior-roof.webp", tag: "Tetto panoramico", title: "La città sopra di te", text: "Il tetto panoramico apre l'abitacolo allo skyline: luce di giorno, luci della città di sera.", cls: "lg:mt-20" },
  { src: "/assets/interior-cockpit.webp", tag: "Abitacolo", title: "Comando totale", text: "Volante compatto, specchietti ripiegabili elettricamente e comandi essenziali: tutto a portata di mano.", cls: "lg:-mt-10" },
  { src: "/assets/interior-door.webp", tag: "Accesso", title: "Si entra, si parte", text: "Porta ad ampia apertura e posizione di guida rialzata: entrare e uscire in città non è mai stato così semplice.", cls: "lg:mt-10" },
];

export function Interior() {
  return (
    <section id="interni" data-testid="interior-section" className="relative overflow-hidden border-t border-white/10 bg-ink py-28 sm:py-40">
      <div className="mx-auto max-w-[1600px] px-5 sm:px-10">
        <SectionTag index="12" label="Interni e digitale" />
        <h2 className="mt-10 font-display font-extrabold uppercase leading-[0.92] tracking-tight">
          <Lines lines={["Small outside."]} className="text-4xl text-white sm:text-6xl lg:text-7xl" />
          <Lines lines={["Big experience."]} delay={0.15} className="text-4xl text-outline sm:text-6xl lg:text-7xl" />
        </h2>

        <div className="mt-16 grid gap-8 sm:grid-cols-2">
          {PANELS.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.12} y={70} className={`group ${p.cls}`}>
              <div className="relative overflow-hidden border border-white/10">
                <img src={p.src} alt={p.title} className="aspect-[16/10] w-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" aria-hidden="true" />
                <div className="absolute inset-x-0 bottom-0 p-6 sm:p-8">
                  <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-swapa-yellow">{p.tag}</p>
                  <h3 className="mt-2 font-display text-2xl font-bold uppercase tracking-tight text-white sm:text-3xl">{p.title}</h3>
                  <p className="mt-2 max-w-md text-sm leading-relaxed text-zinc-400">{p.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.25}>
          <div className="mt-10 flex flex-wrap gap-2.5">
            {["Bluetooth", "Due porte USB", "Connettività", "Dettagli curati"].map((t) => (
              <span key={t} className="border border-white/15 px-4 py-2 font-mono text-[10px] uppercase tracking-[0.15em] text-zinc-400">{t}</span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
